export const MIN_UPDATE_DIFFERENCE_MS = 1000 * 60 * 60 * 24 * 14; // 14 days
